import React from 'react';
import styled from 'styled-components';
import SignUpLockIconSvg from '../../stories/assets/SignUpLock.svg';

const SignUpLockIcon = styled(SignUpLockIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
`;

export default SignUpLockIcon;
